/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAISessionFromJSON, ApiAISessionToJSON, } from './ApiAISession';
export function ApiListAISessionsResponseFromJSON(json) {
    return ApiListAISessionsResponseFromJSONTyped(json, false);
}
export function ApiListAISessionsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sessions': !exists(json, 'sessions') ? undefined : (json['sessions'].map(ApiAISessionFromJSON)),
    };
}
export function ApiListAISessionsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sessions': value.sessions === undefined ? undefined : (value.sessions.map(ApiAISessionToJSON)),
    };
}
